import { MultiVoucherWidget } from 'app/src/features/Shopping/Direct/MultiVoucher/components/MultiVoucherWidget'
import { VoucherLeftPanelSide } from 'app/src/features/Shopping/Direct/Voucher/components/VoucherLeftPanelSide'
import { VoucherRightPanelSide } from 'app/src/features/Shopping/Direct/Voucher/components/VoucherRightPanelSide'
import type { shoppingApi } from 'app/src/services/welfareportal'
import { BackToCatalogButton, Image } from 'app/src/shared/components'
import errorBlock from 'app/static/images/error_block.png'
import successImage from 'app/static/images/success_img.png'
import successPartial from 'app/static/images/success_partial.png'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

export function MultiVoucherDetails(props: {
  parentOrder: shoppingApi.OrderDetails
  orders: shoppingApi.OrderListItem[]
  funnelMode?: boolean
}) {
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct.MultiVoucher' })
  const [showUsageModal, setShowUsageModal] = useState(false)

  const renderMultiOrderHeader = useMemo(() => {
    const nFailed: number = props.orders.filter((v) => v.status == 'rejected')?.length
    if (nFailed > 0) {
      if (nFailed == props.orders.length)
        return (
          <div className='noPrint'>
            <Image
              pt={{ image: { className: 'object-fit mx-auto h-[150px] lg:h-[250px]' } }}
              src={errorBlock}
              alt='Immagine di errore'
            />
            <h1 className='welfareportal-titlecenter'>{t('errorAllFailedMsg1')}</h1>
            <h1 className='welfareportal-titlecenter'>{t('errorAllFailedMsg2')}</h1>
          </div>
        )
      else
        return (
          <div className='noPrint'>
            <Image
              pt={{ image: { className: 'object-fit mx-auto h-[150px] lg:h-[250px]' } }}
              src={successPartial}
              alt='Immagine di successo parziale'
            />
            <h1 className='welfareportal-titlecenter'>{t('errorAnyFailedMsg1')}</h1>
            <h1 className='welfareportal-titlecenter'>{t('errorAnyFailedMsg2', { NFAILED: nFailed })}</h1>
            <h1 className='welfareportal-titlecenter'>{t('errorAnyFailedMsg3', { NOK: props.orders.length - nFailed })}</h1>
          </div>
        )
    } else
      return (
        <div className='noPrint'>
          <Image
            pt={{ image: { className: 'object-fit mx-auto h-[150px] lg:h-[250px]' } }}
            src={successImage}
            alt='Immagine di successo'
          />
          <h1 className='welfareportal-titlecenter'>{t('successMessageMsg1')}</h1>
          <h1 className='welfareportal-titlecenter'>{t('successMessageMsg2')}</h1>
        </div>
      )
  }, [props.orders, t])

  const renderMultiOrder = useMemo(() => {
    if (props.orders.length == 1 && props.orders[0].status == 'confirmed')
      return (
        <div className='mx-auto mt-7 max-w-5xl'>
          <MultiVoucherWidget parentOrder={props.parentOrder} orderListItem={props.orders[0]} />
        </div>
      )
    else
      return (
        <div className='mt-7 grid grid-cols-1 gap-5 xl:grid-cols-2'>
          {props.orders
            .filter((v) => v.status == 'confirmed')
            .map((v, i) => {
              if (i % 2 == 0)
                return (
                  <div className='col-span-1 col-start-1' key={i}>
                    <MultiVoucherWidget parentOrder={props.parentOrder} orderListItem={v} />
                  </div>
                )
              else
                return (
                  <div className='col-span-1 col-start-1 xl:col-start-2' key={i}>
                    <MultiVoucherWidget parentOrder={props.parentOrder} orderListItem={v} />
                  </div>
                )
            })}
        </div>
      )
  }, [props.parentOrder, props.orders])

  return (
    <div>
      {typeof props.funnelMode === 'undefined' || !props.funnelMode ? (
        <div className='noPrint'>
          <h1 className='welfareportal-titlecenter'>{t('detailPageTitle')}</h1>
          <div className='card grid grid-cols-1 divide-x-0 divide-y-2 p-5 lg:grid-cols-12 lg:divide-x-2 lg:divide-y-0'>
            <VoucherLeftPanelSide
              statusMode
              order={props.parentOrder}
              setShowUsageModal={setShowUsageModal}
              showUsageModal={showUsageModal}
            />
            <VoucherRightPanelSide order={props.parentOrder} />
          </div>
        </div>
      ) : (
        renderMultiOrderHeader
      )}

      {renderMultiOrder}

      {props.funnelMode && (
        <div className='mx-auto mt-2 flex justify-center'>
          <BackToCatalogButton />
        </div>
      )}
    </div>
  )
}
